// import React, { useEffect, useMemo, useRef, useState } from "react";
// import * as LightweightCharts from "lightweight-charts";
// import { useSpreadKlines } from "../hooks/klines/useSpreadKlines";

// const VISIBLE_BARS_INIT = 20;
// const BAR_SPACING_PX = 8;
// const INTERVALS = ["1m", "5m", "15m", "30m", "4h"];

// const SpreadChart = ({
//   symbol,
//   left,
//   right,
//   interval = "1m",
//   onIntervalChange,
//   showIntervalToolbar = true,
//   height = 250,
// }) => {
//   const [localInterval, setLocalInterval] = useState(interval);
//   const effectiveInterval = onIntervalChange ? interval : localInterval;

//   const inputsKey = useMemo(
//     () => JSON.stringify({ symbol, left, right, tf: effectiveInterval }),
//     [symbol, left, right, effectiveInterval]
//   );
//   const [chartInstanceKey, setChartInstanceKey] = useState(() => inputsKey);

//   const containerRef = useRef(null);
//   const chartRef = useRef(null);
//   const seriesRef = useRef(null);
//   const zeroLineRef = useRef(null);
//   const legendRef = useRef(null);
//   const lastCloseRef = useRef(null);
//   const lastBarTimeRef = useRef(null);

//   const { candles, loading } = useSpreadKlines({
//     symbol,
//     left,
//     right,
//     interval: effectiveInterval,
//     limit: 300,
//   });

//   const mskTimeFormatter = useMemo(() => {
//     const fmt = new Intl.DateTimeFormat("ru-RU", {
//       timeZone: "Europe/Moscow",
//       year: "2-digit",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false,
//     });
//     return (time) => {
//       let d;
//       if (typeof time === "object" && time && "year" in time) {
//         d = new Date(Date.UTC(time.year, time.month - 1, time.day, 0, 0, 0));
//       } else {
//         d = new Date((time ?? 0) * 1000);
//       }
//       return fmt.format(d).replace(",", "");
//     };
//   }, []);

//   const mskTickFormatter = useMemo(() => {
//     const fmt = new Intl.DateTimeFormat("ru-RU", {
//       timeZone: "Europe/Moscow",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false,
//     });
//     return (time) => {
//       let d;
//       if (typeof time === "object" && time && "year" in time) {
//         d = new Date(Date.UTC(time.year, time.month - 1, time.day, 0, 0, 0));
//       } else {
//         d = new Date((time ?? 0) * 1000);
//       }
//       return fmt.format(d).replace(",", "");
//     };
//   }, []);

//   const setLegend = (time, price) => {
//     const el = legendRef.current;
//     if (!el) return;
//     const p = Number(price);
//     const priceStr = Number.isFinite(p) ? `${p.toFixed(3)}%` : "—";
//     const timeStr = time ? mskTimeFormatter(time) : "";
//     el.textContent = time ? `${timeStr}  •  ${priceStr}` : priceStr;
//   };

//   useEffect(() => {
//     setChartInstanceKey(inputsKey);
//     lastBarTimeRef.current = null;
//     lastCloseRef.current = null;
//     console.log("[SpreadChart] inputs changed → remount chart", { inputsKey });
//   }, [inputsKey]);

//   useEffect(() => {
//     if (!containerRef.current) {
//       console.log("[SpreadChart] no container ref yet");
//       return;
//     }

//     console.log("[SpreadChart] init chart", {
//       chartInstanceKey,
//       containerWidth: containerRef.current.clientWidth,
//       containerHeight: containerRef.current.clientHeight,
//       requestedHeight: height
//     });

//     const chart = LightweightCharts.createChart(containerRef.current, {
//       width: containerRef.current.clientWidth,
//       height,
//       layout: {
//         background: { type: "Solid", color: "#0b0e11" },
//         textColor: "#cbd5e1",
//       },
//       grid: {
//         vertLines: { color: "rgba(197,203,206,0.2)" },
//         horzLines: { color: "rgba(197,203,206,0.2)" },
//       },
//       rightPriceScale: { borderVisible: false, autoScale: true },
//       timeScale: {
//         borderVisible: false,
//         timeVisible: true,
//         secondsVisible: false,
//         tickMarkFormatter: mskTickFormatter,
//         barSpacing: BAR_SPACING_PX,
//       },
//       localization: {
//         priceFormatter: (p) => `${p.toFixed(3)}%`,
//         timeFormatter: mskTimeFormatter,
//       },
//       crosshair: { mode: LightweightCharts.CrosshairMode.Normal },
//     });

//     console.log("[SpreadChart] chart created", {
//       hasContainer: !!containerRef.current,
//       chartCreated: !!chart,
//       actualWidth: chart.options().width,
//       actualHeight: chart.options().height
//     });

//     const series = chart.addCandlestickSeries({
//       upColor: "#22c55e",
//       downColor: "#ef4444",
//       borderUpColor: "#22c55e",
//       borderDownColor: "#ef4444",
//       wickUpColor: "#22c55e",
//       wickDownColor: "#ef4444",
//       priceFormat: { type: "price", precision: 3, minMove: 0.001 },
//     });

//     const zeroLine = series.createPriceLine({
//       price: 0,
//       color: "rgba(180,180,180,0.8)",
//       lineWidth: 2,
//       lineStyle: LightweightCharts.LineStyle.Solid,
//       axisLabelVisible: true,
//     });

//     chartRef.current = chart;
//     seriesRef.current = series;
//     zeroLineRef.current = zeroLine;

//     const onCrosshairMove = (param) => {
//       if (!param?.point || !seriesRef.current || !chartRef.current) {
//         setLegend(undefined, lastCloseRef.current);
//         return;
//       }
//       const { x, y } = param.point;
//       const price = seriesRef.current.coordinateToPrice(y);
//       const t = chartRef.current.timeScale().coordinateToTime(x);
//       if (price !== undefined) setLegend(t, price);
//       else setLegend(undefined, lastCloseRef.current);
//     };
//     chart.subscribeCrosshairMove(onCrosshairMove);

//     // ---------- FIX ResizeObserver warning: throttle via rAF ----------
//     let resizeRAF = 0;
//     const ro = new ResizeObserver((entries) => {
//       const entry = entries[0];
//       const width = Math.floor(entry?.contentRect?.width || 0);
//       if (!width) return;
//       if (resizeRAF) cancelAnimationFrame(resizeRAF);
//       resizeRAF = requestAnimationFrame(() => {
//         if (chartRef.current) {
//           chartRef.current.applyOptions({ width });
//         }
//       });
//     });
//     try {
//       ro.observe(containerRef.current, { box: "border-box" });
//     } catch {
//       ro.observe(containerRef.current);
//     }
//     // ---------------------------------------------------------------

//     return () => {
//       try {
//         chart.unsubscribeCrosshairMove(onCrosshairMove);
//         ro.disconnect();
//         if (resizeRAF) cancelAnimationFrame(resizeRAF);
//       } catch {}
//       try { chart.remove(); } catch {}
//       chartRef.current = null;
//       seriesRef.current = null;
//       zeroLineRef.current = null;
//       lastBarTimeRef.current = null;
//       lastCloseRef.current = null;
//       console.log("[SpreadChart] dispose chart", { chartInstanceKey });
//     };
//   }, [chartInstanceKey, height, mskTickFormatter, mskTimeFormatter]);

//   useEffect(() => {
//     const series = seriesRef.current;
//     const chart = chartRef.current;
//     if (!series || !chart) {
//       console.log("[SpreadChart] no series/chart refs yet");
//       return;
//     }

//     if (!candles || candles.length === 0) {
//       console.log("[SpreadChart] setData EMPTY", {
//         hasChart: !!chart,
//         hasSeries: !!series,
//         candles: candles?.length ?? 0
//       });
//       series.setData([]);
//       lastBarTimeRef.current = null;
//       return;
//     }

//     if (!lastBarTimeRef.current) {
//       console.log("[SpreadChart] setData FULL", {
//         count: candles.length,
//         firstCandle: candles[0],
//         lastCandle: candles[candles.length - 1],
//         chartWidth: chart.options().width,
//         chartHeight: chart.options().height
//       });
//       series.setData(candles);

//       const n = candles.length;
//       const last = candles[n - 1];
//       const first = candles[Math.max(0, n - VISIBLE_BARS_INIT)];
//       lastBarTimeRef.current = last.time ?? null;

//       lastCloseRef.current = Number(last?.close ?? last?.value ?? 0);
//       setLegend(last?.time, lastCloseRef.current);

//       if (n < 2) chart.timeScale().fitContent();
//       else chart.timeScale().setVisibleRange({ from: first.time, to: last.time });

//       return;
//     }

//     const last = candles[candles.length - 1];
//     const prevTime = lastBarTimeRef.current;

//     if (prevTime == null || last.time > prevTime) {
//       console.log("[SpreadChart] update NEW", last.time);
//       series.update(last);
//       lastBarTimeRef.current = last.time;
//       lastCloseRef.current = Number(last?.close ?? last?.value ?? lastCloseRef.current);
//     } else if (last.time === prevTime) {
//       console.log("[SpreadChart] update SAME", last.time);
//       series.update(last);
//       lastCloseRef.current = Number(last?.close ?? last?.value ?? lastCloseRef.current);
//     } else {
//       console.log("[SpreadChart] setData REPLACE (out-of-order)", { count: candles.length });
//       series.setData(candles);
//       lastBarTimeRef.current = last.time;
//       lastCloseRef.current = Number(last?.close ?? last?.value ?? lastCloseRef.current);
//     }
//   }, [candles]);

//   const handleIntervalClick = (tf) => {
//     if (tf === effectiveInterval) return;
//     console.log("[SpreadChart] click interval", { from: effectiveInterval, to: tf });
//     if (onIntervalChange) onIntervalChange(tf);
//     else setLocalInterval(tf);
//   };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: 6, height: "100%" }}>
//       <div
//         key={chartInstanceKey}
//         style={{ position: "relative", height, borderRadius: 12, overflow: "hidden", background: "#0b0e11" }}
//       >
//         <div ref={containerRef} style={{ height: "100%" }} />
//         <div
//           ref={legendRef}
//           style={{
//             position: "absolute",
//             left: 12,
//             top: 8,
//             padding: "4px 8px",
//             borderRadius: 6,
//             fontSize: 12,
//             background: "rgba(17, 24, 39, 0.6)",
//             color: "#e5e7eb",
//             backdropFilter: "blur(2px)",
//             pointerEvents: "none",
//             userSelect: "none",
//             whiteSpace: "nowrap",
//             zIndex: 10,
//           }}
//         />
//         {showIntervalToolbar && (
//           <div
//             style={{
//               position: "absolute",
//               right: 12,
//               top: 8,
//               display: "flex",
//               gap: 6,
//               background: "rgba(17, 24, 39, 0.6)",
//               padding: "4px",
//               borderRadius: 8,
//               backdropFilter: "blur(2px)",
//               zIndex: 10,
//             }}
//           >
//             {INTERVALS.map((tf) => {
//               const active = tf === effectiveInterval;
//               return (
//                 <button
//                   key={tf}
//                   onClick={() => handleIntervalClick(tf)}
//                   style={{
//                     fontSize: 12,
//                     lineHeight: "18px",
//                     padding: "4px 8px",
//                     borderRadius: 6,
//                     border: "1px solid rgba(148,163,184,0.25)",
//                     background: active ? "rgba(59,130,246,0.25)" : "transparent",
//                     color: active ? "#cfe3ff" : "#e5e7eb",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {tf}
//                 </button>
//               );
//             })}
//           </div>
//         )}
//       </div>

//       {loading && (
//         <div style={{ fontSize: 12, color: "#a1a1aa" }}>Загружаем свечи…</div>
//       )}
//     </div>
//   );
// };

// export default SpreadChart;
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as LightweightCharts from "lightweight-charts";
import { useSpreadKlines } from "../hooks/klines/useSpreadKlines";

const VISIBLE_BARS_INIT = 20;
const BAR_SPACING_PX = 8;
const INTERVALS = ["1m", "5m", "15m", "30m", "4h"];

const SpreadChart = ({
  symbol,
  left,
  right,
  interval = "1m",
  onIntervalChange,
  showIntervalToolbar = true,
  /** новое: скрыть «таймбар» внизу (ось времени) */
  showTimeAxis = false,
  /** новое: скрыть легенду в левом верхнем углу */
  showLegend = false,
  height = 250,
}) => {
  const [localInterval, setLocalInterval] = useState(interval);
  const effectiveInterval = onIntervalChange ? interval : localInterval;

  const inputsKey = useMemo(
    () => JSON.stringify({ symbol, left, right, tf: effectiveInterval }),
    [symbol, left, right, effectiveInterval]
  );
  const [chartInstanceKey, setChartInstanceKey] = useState(() => inputsKey);

  const containerRef = useRef(null);
  const chartRef = useRef(null);
  const seriesRef = useRef(null);
  const zeroLineRef = useRef(null);
  const legendRef = useRef(null);
  const lastCloseRef = useRef(null);
  const lastBarTimeRef = useRef(null);

  const { candles, loading } = useSpreadKlines({
    symbol,
    left,
    right,
    interval: effectiveInterval,
    limit: 300,
  });

  const mskTimeFormatter = useMemo(() => {
    const fmt = new Intl.DateTimeFormat("ru-RU", {
      timeZone: "Europe/Moscow",
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return (time) => {
      let d;
      if (typeof time === "object" && time && "year" in time) {
        d = new Date(Date.UTC(time.year, time.month - 1, time.day, 0, 0, 0));
      } else {
        d = new Date((time ?? 0) * 1000);
      }
      return fmt.format(d).replace(",", "");
    };
  }, []);

  const mskTickFormatter = useMemo(() => {
    const fmt = new Intl.DateTimeFormat("ru-RU", {
      timeZone: "Europe/Moscow",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return (time) => {
      let d;
      if (typeof time === "object" && time && "year" in time) {
        d = new Date(Date.UTC(time.year, time.month - 1, time.day, 0, 0, 0));
      } else {
        d = new Date((time ?? 0) * 1000);
      }
      return fmt.format(d).replace(",", "");
    };
  }, []);

  const setLegend = (time, price) => {
    if (!showLegend) return;
    const el = legendRef.current;
    if (!el) return;
    const p = Number(price);
    const priceStr = Number.isFinite(p) ? `${p.toFixed(3)}%` : "—";
    const timeStr = time ? mskTimeFormatter(time) : "";
    el.textContent = time ? `${timeStr}  •  ${priceStr}` : priceStr;
  };

  useEffect(() => {
    setChartInstanceKey(inputsKey);
    lastBarTimeRef.current = null;
    lastCloseRef.current = null;
    console.log("[SpreadChart] inputs changed → remount chart", { inputsKey });
  }, [inputsKey]);

  useEffect(() => {
    if (!containerRef.current) return;

    console.log("[SpreadChart] init chart", {
      chartInstanceKey,
      containerWidth: containerRef.current.clientWidth,
      containerHeight: containerRef.current.clientHeight,
      requestedHeight: height,
    });

    const chart = LightweightCharts.createChart(containerRef.current, {
      width: containerRef.current.clientWidth,
      height,
      layout: {
        background: { type: "Solid", color: "#0b0e11" },
        textColor: "#cbd5e1",
      },
      grid: {
        vertLines: { color: "rgba(197,203,206,0.2)" },
        horzLines: { color: "rgba(197,203,206,0.2)" },
      },
      rightPriceScale: { borderVisible: false, autoScale: true },
      timeScale: {
        /** ключевой флажок — скрываем ось времени и таймбар снизу */
        visible: !!showTimeAxis,
        borderVisible: false,
        timeVisible: true,
        secondsVisible: false,
        tickMarkFormatter: mskTickFormatter,
        barSpacing: BAR_SPACING_PX,
      },
      localization: {
        priceFormatter: (p) => `${p.toFixed(3)}%`,
        timeFormatter: mskTimeFormatter,
      },
      crosshair: {
        mode: LightweightCharts.CrosshairMode.Normal,
        // чтобы не было яркой подсветки осей, если ось времени скрыта
        vertLine: { labelVisible: false },
        horzLine: { labelVisible: false },
      },
    });

    const series = chart.addCandlestickSeries({
      upColor: "#22c55e",
      downColor: "#ef4444",
      borderUpColor: "#22c55e",
      borderDownColor: "#ef4444",
      wickUpColor: "#22c55e",
      wickDownColor: "#ef4444",
      priceFormat: { type: "price", precision: 3, minMove: 0.001 },
    });

    const zeroLine = series.createPriceLine({
      price: 0,
      color: "rgba(180,180,180,0.8)",
      lineWidth: 2,
      lineStyle: LightweightCharts.LineStyle.Solid,
      axisLabelVisible: true,
    });

    chartRef.current = chart;
    seriesRef.current = series;
    zeroLineRef.current = zeroLine;

    const onCrosshairMove = (param) => {
      if (!showLegend) return; // легенда скрыта — никакого пересчёта
      if (!param?.point || !seriesRef.current || !chartRef.current) {
        setLegend(undefined, lastCloseRef.current);
        return;
      }
      const { x, y } = param.point;
      const price = seriesRef.current.coordinateToPrice(y);
      const t = chartRef.current.timeScale().coordinateToTime(x);
      if (price !== undefined) setLegend(t, price);
      else setLegend(undefined, lastCloseRef.current);
    };
    chart.subscribeCrosshairMove(onCrosshairMove);

    // ---------- троттлим resize через rAF ----------
    let resizeRAF = 0;
    const ro = new ResizeObserver((entries) => {
      const entry = entries[0];
      const width = Math.floor(entry?.contentRect?.width || 0);
      if (!width) return;
      if (resizeRAF) cancelAnimationFrame(resizeRAF);
      resizeRAF = requestAnimationFrame(() => {
        if (chartRef.current) chartRef.current.applyOptions({ width });
      });
    });
    try {
      ro.observe(containerRef.current, { box: "border-box" });
    } catch {
      ro.observe(containerRef.current);
    }

    return () => {
      try {
        chart.unsubscribeCrosshairMove(onCrosshairMove);
        ro.disconnect();
        if (resizeRAF) cancelAnimationFrame(resizeRAF);
      } catch {}
      try { chart.remove(); } catch {}
      chartRef.current = null;
      seriesRef.current = null;
      zeroLineRef.current = null;
      lastBarTimeRef.current = null;
      lastCloseRef.current = null;
      console.log("[SpreadChart] dispose chart", { chartInstanceKey });
    };
  }, [chartInstanceKey, height, mskTickFormatter, mskTimeFormatter, showTimeAxis, showLegend]);

  useEffect(() => {
    const series = seriesRef.current;
    const chart = chartRef.current;
    if (!series || !chart) return;

    if (!candles || candles.length === 0) {
      console.log("[SpreadChart] setData EMPTY", {
        hasChart: !!chart,
        hasSeries: !!series,
        candles: candles?.length ?? 0,
      });
      series.setData([]);
      lastBarTimeRef.current = null;
      return;
    }

    if (!lastBarTimeRef.current) {
      console.log("[SpreadChart] setData FULL", {
        count: candles.length,
        firstCandle: candles[0],
        lastCandle: candles[candles.length - 1],
        chartWidth: chart.options().width,
        chartHeight: chart.options().height,
      });
      series.setData(candles);

      const n = candles.length;
      const last = candles[n - 1];
      const first = candles[Math.max(0, n - VISIBLE_BARS_INIT)];
      lastBarTimeRef.current = last.time ?? null;

      lastCloseRef.current = Number(last?.close ?? last?.value ?? 0);
      setLegend(last?.time, lastCloseRef.current);

      if (n < 2) chart.timeScale().fitContent();
      else chart.timeScale().setVisibleRange({ from: first.time, to: last.time });

      return;
    }

    const last = candles[candles.length - 1];
    const prevTime = lastBarTimeRef.current;

    if (prevTime == null || last.time > prevTime) {
      series.update(last);
      lastBarTimeRef.current = last.time;
      lastCloseRef.current = Number(last?.close ?? last?.value ?? lastCloseRef.current);
    } else if (last.time === prevTime) {
      series.update(last);
      lastCloseRef.current = Number(last?.close ?? last?.value ?? lastCloseRef.current);
    } else {
      series.setData(candles);
      lastBarTimeRef.current = last.time;
      lastCloseRef.current = Number(last?.close ?? last?.value ?? lastCloseRef.current);
    }
  }, [candles, showLegend]); // showLegend, чтобы корректно обновлялась первая отрисовка легенды

  const handleIntervalClick = (tf) => {
    if (tf === effectiveInterval) return;
    if (onIntervalChange) onIntervalChange(tf);
    else setLocalInterval(tf);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, height: "100%" }}>
      <div
        key={chartInstanceKey}
        style={{
          position: "relative",
          height,
          borderRadius: 12,
          overflow: "hidden",
          background: "#0b0e11",
        }}
      >
        <div ref={containerRef} style={{ height: "100%" }} />

        {/* легенда слева сверху — теперь по флажку */}
        {showLegend && (
          <div
            ref={legendRef}
            style={{
              position: "absolute",
              left: 12,
              top: 8,
              padding: "4px 8px",
              borderRadius: 6,
              fontSize: 12,
              background: "rgba(17, 24, 39, 0.6)",
              color: "#e5e7eb",
              backdropFilter: "blur(2px)",
              pointerEvents: "none",
              userSelect: "none",
              whiteSpace: "nowrap",
              zIndex: 10,
            }}
          />
        )}

        {/* оставляем только выбор таймфрейма */}
        {showIntervalToolbar && (
          <div
            style={{
              position: "absolute",
              right: 12,
              top: 8,
              display: "flex",
              gap: 6,
              background: "rgba(17, 24, 39, 0.6)",
              padding: "4px",
              borderRadius: 8,
              backdropFilter: "blur(2px)",
              zIndex: 10,
            }}
          >
            {INTERVALS.map((tf) => {
              const active = tf === effectiveInterval;
              return (
                <button
                  key={tf}
                  onClick={() => handleIntervalClick(tf)}
                  style={{
                    fontSize: 12,
                    lineHeight: "18px",
                    padding: "4px 8px",
                    borderRadius: 6,
                    border: "1px solid rgba(148,163,184,0.25)",
                    background: active ? "rgba(59,130,246,0.25)" : "transparent",
                    color: active ? "#cfe3ff" : "#e5e7eb",
                    cursor: "pointer",
                  }}
                >
                  {tf}
                </button>
              );
            })}
          </div>
        )}
      </div>

      {loading && (
        <div style={{ fontSize: 12, color: "#a1a1aa" }}>Загружаем свечи…</div>
      )}
    </div>
  );
};

export default SpreadChart;
